import { useState } from 'react'
import Header from '../pages/Template/Header'
import Footer from '../pages/Template/Footer'
import AlertMessage from '../pages/Alert/AlertMessage';

import { useAuth } from '../contexts/auth2';
import { NavLink , useLocation} from 'react-router-dom';
import { Home, Users, ClipboardPlus, BellRing, Cog, LogOut, Search } from 'lucide-react';

const Layout = ({ children }) => {

  const location = useLocation();
  const currentPath = location.pathname;

  const [alert, setAlert] = useState(null);

  const {logout, signed, user} = useAuth();
  const[searchTerm, setSearchTerm] = useState('');

  const menuItems = [
    { to: '/dashboard', icon: <Home size={20} />, label: 'Início' },
    { to: '/patients', icon: <Users size={20} />, label: 'Pacientes' },
    { to: '/medications', icon: <ClipboardPlus size={20} />, label: 'Medicamentos' },
    { to: '/notificacoes', icon: <BellRing size={20} />, label: 'Notificações' },
  ];


  // Função genérica de alerta
  // Função genérica de alerta
  const showAlert = (
    type,
    message,
    onConfirm = null,
    okText = 'OK',
    cancelText = 'Cancelar'
  ) => {
    setAlert({
      type,
      message,
      onConfirm,
      okText,
      cancelText,
    });
  };
  
  const signout = async () => {
      showAlert(
      'confirm',
      'Deseja sair da sua conta?',
      async () => {
        await logout();
      },
      'Sim, desejo sair',
      'Cancelar'
    );
  }

  const handleSubmitSearch = async (e) => {
        //e.preventDefault();

        const payload = {
            term: searchTerm,
        };

        try {
            //await signup(payload);
        } catch (error) {
            console.error("Erro no cadastro:", error);
        }
  }
  
  return (
    <>
      {alert && (
        <AlertMessage
          type={alert.type}
          message={alert.message}
          icon={<LogOut size={22} color="#101828" />} // 👈 passa o ícone aqui
          onClose={() => setAlert(null)}
          onConfirm={alert.onConfirm}
          okText={alert.okText}
          cancelText={alert.cancelText}
        />
      )}
      <div className='box'>
        <div className='box1'>

          <div className='content-sid'>

            <div className='box-sid-1'>

              <div className='sid-logo'>
                <div className="sid-logo-img">
                  <img src='/files/img/logo-2.svg'/>
                </div>
                <div className="sid-search">

                  <form action="/pacients" onSubmit={handleSubmitSearch}>

                      <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                        <Search size={20} color="#777" style={{
                          position: 'absolute',
                          left: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          pointerEvents: 'none'
                        }}/>

                        <input 
                          type="text" 
                          name="s" placeholder="Search"
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{
                              paddingLeft: '35px',
                              height: '36px',
                              width: '100%',
                              boxSizing: 'border-box'
                            }}
                        />
                      </div>

                  </form>

                </div>
              </div>

              <div className='menu-lateral'>
                
                <ul className="menu-lateral-all">
                  
                  {menuItems.map((item, index) => (
                    <li
                      key={index}
                      className={currentPath === item.to ? 'bg-menu-lateral-selected' : ''}
                    >
                      <NavLink to={item.to}>
                        {item.icon}
                        <div className='menu-lateral-str'>{item.label}</div>
                      </NavLink>
                    </li>
                  ))}
                  
                </ul>

              </div>

            </div>

            <div className='box-sid-2'>

              <ul className="menu-lateral-all">
                <li
                  className={currentPath === "/myaccount" ? 'bg-menu-lateral-selected' : ''}
                >
                  <NavLink to="/myaccount">
                    <Cog size={20}/>
                    <div className='menu-lateral-str'>Ajustes</div>
                  </NavLink>
                </li>
              </ul>

                <div className='user-inf'>
                  <div className='user-inf-img'>
                    <img width="100" src="/files/img/user-padrao.png"/>
                  </div>
                  <div className='user-inf-data'>
                    <h2>{user.user?.name || 'Usuário'}</h2>
                    <h3>{user.user?.email || ''}</h3>
                  </div>
                  <div className='user-inf-logout'>
                    <LogOut size={17} onClick={signout} style={{cursor: "pointer"}}/>
                  </div>
                </div>

            </div>

            

            

          </div>

        </div>
        <div className='box2'>
          <div className='content-single'>{children}</div>
        </div>
      </div>
      
    </>
  );
};

export default Layout;